import React, { useState } from 'react';
import { Typography } from 'interfaces/typography';
import { RecordVM } from '../RecordVM';
import { VoicemailGreeting } from '../VoicemailGreeting';

enum VoicemailTab {
  DROP = 'Voicemail Drop',
  GREETING = 'Voicemail Greeting'
}

export const VoicemailManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<VoicemailTab>(VoicemailTab.DROP);

  const renderTabButton = (tab: VoicemailTab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-4 py-2 border-b-2 transition-colors duration-200 ${
        activeTab === tab
          ? 'border-blue-600'
          : 'border-transparent hover:border-gray-300'
      }`}
    >
      <Typography
        variant="mediumParagraph"
        color={activeTab === tab ? '#2563eb' : '#6b7280'}
        fontWeight={500}
      >
        {tab}
      </Typography>
    </button>
  );

  const renderContent = () => {
    switch (activeTab) {
      case VoicemailTab.DROP:
        return <RecordVM />;
      case VoicemailTab.GREETING:
        return <VoicemailGreeting />;
      default:
        return <RecordVM />;
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header with title and tabs */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="mb-4">
          <Typography variant="h2" color="#1F2937" fontWeight={600}>
            Voicemail Management
          </Typography>
          <Typography variant="smallParagraph" color="#6B7280" style={{ marginTop: '0.25rem' }}>
            Create voicemail drops for manual sending and set a greeting for incoming calls
          </Typography>
        </div>

        {/* Tab Navigation */}
        <div className="flex space-x-6 border-b border-gray-200">
          {Object.values(VoicemailTab).map(tab => renderTabButton(tab))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {renderContent()}
      </div>
    </div>
  );
};
